import { destroy, Instance, types } from 'mobx-state-tree';
import { Moment } from 'moment';
import { MomentDate } from '@models/shared/MomentDate';
import { TimelineItemTypeType } from '@app-types/timetable';
import { MoveItemArgs } from './Timetable/types';
import { refreshTimetable } from './Timetable/functions/refreshTimetable';

export const TimelineItem = types
  .model({
    id: types.identifier,
    elementID: types.maybeNull(types.string),
    groupID: types.string,
    title: types.string,
    duration: types.number,
    startTime: MomentDate,
    endTime: MomentDate,
    color: types.string,
    batchClassID: types.string,
    itemType: types.enumeration<TimelineItemTypeType>('TimelineItemTypeType', Object.values(TimelineItemTypeType)),
    lecturerID: types.maybeNull(types.string),
    locationID: types.maybe(types.string),
    subjectName: types.maybe(types.string),
    published: false,
    dbId: types.maybeNull(types.string),
    batchName: types.maybeNull(types.string),
    batchClassName: types.maybeNull(types.string),
  })
  .actions((self) => ({
    moveItem({ startTime, endTime, groupID }: MoveItemArgs) {
      self.startTime = startTime;
      self.endTime = endTime;
      self.groupID = groupID;

      refreshTimetable();
    },
    setStartTime(startTime: Moment) {
      self.startTime = startTime;

      refreshTimetable();
    },
    setEndTime(endTime: Moment) {
      self.endTime = endTime;

      refreshTimetable();
    },
    removeItem() {
      destroy(self);
    },
  }));

export type TimelineItemModelType = Instance<typeof TimelineItem>;
